import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, PIXEL_CONTENT_NAME, pricing } from '../data/poolContent';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-298" data-mp="3ubu2ppl0kx39">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-aqua/25 bg-abyss-950/95 px-3 pb-[max(0.625rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur lg:hidden" data-id="element-299" data-mp="3glgs1fgqn4a8">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-300" data-mp="75m9wbrf5mem">
            <div className="shrink-0 leading-none" data-id="element-301" data-mp="73t40yomr67o">
              <p className="font-display text-2xl font-bold text-frost-50" data-id="element-302" data-mp="27kjf5rnykt4">
                {pricing.today}
                <span className="ml-1 align-middle font-sans text-[9px] font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-303" data-mp="gwqmj4tmgv6a">
                  USD
                </span>
              </p>
              <p className="mt-1 text-[9px] uppercase tracking-[0.12em] text-muted" data-id="element-304" data-mp="pvltij4hq9an">
                Value <span className="line-through" data-id="element-305" data-mp="lvjteeeelnxh">{pricing.regularPrice}</span>
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: PIXEL_CONTENT_NAME,
          value: pricing.todayValue,
          currency: 'USD'
        })} className="flex min-w-0 flex-1 items-center justify-center whitespace-nowrap rounded-full bg-aqua px-3 py-3 text-center text-[11px] font-bold uppercase leading-none tracking-[0.1em] text-abyss-950 transition-colors duration-150 ease-out active:bg-aqua-light" data-id="element-306" data-mp="zti499tin288">
              Get the guide now
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}